export default __webpack_public_path__ + "static/media/ArrowRightWhite.fc9ef21f.svg";